import { fetcher } from "utils";
import { IJSendSuccessResponse, IWithMeta, IOrderProductHistoryDetailSerialized } from "typings";

type MemberOrderProductsFetcherByOrderNum = (
  orderNum: string
) => Promise<IJSendSuccessResponse<IWithMeta<IOrderProductHistoryDetailSerialized, {}>>>;
export const get__api__v1__members__order_products__order_num: MemberOrderProductsFetcherByOrderNum = orderNum =>
  fetcher.get(`/api/v1/members/order_products/${orderNum}`);
